import { apiClient } from '@devd-client/api';
import { getToken, getOrgId } from '@devd-client/devd/auth';

export const getCustomMetrics = (): Promise<any> =>
  apiClient(`/v1/custom-metric/${getOrgId()}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const addCustomMetrics = (params: any): Promise<any> =>
  apiClient(`/v1/custom-metric`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({ ...params, orgId: getOrgId() }),
  });

export const updateCustomMetrics = (params: any): Promise<any> =>
  apiClient(`/v1/custom-metric`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({ ...params, orgId: getOrgId() }),
  });

export const deleteCustomMetrics = (params: any): Promise<any> =>
  apiClient(`/v1/custom-metric`, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({ ...params, orgId: getOrgId() }),
  });

export const getCustomField = (): Promise<any> =>
  apiClient(`/v1/integration/org/${getOrgId()}/customFields`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `bearer ${getToken()}`,
    },
  });

export const getMeasure = (): Promise<any> =>
  apiClient(`/v1/metrics-metadata?type=measure`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });

export const getCustomMetricsByName = (metric: string): Promise<any> =>
  apiClient(`/v1/custom-metric/${getOrgId()}/metrics/${metric}`, {
    method: 'GET',
    headers: {
      authorization: `bearer ${getToken()}`,
    },
  });
